module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_m_erythristic.495bc746.png";